import { MdContentPaste } from "react-icons/md";

export const PasteIcon = ({ ...rest }) => {
  return <MdContentPaste {...rest} />;
};
